import { formateDateToJalali, genderConverter } from "../../../utils/Functions";

const TestInfo = ({ data }: any) => {
  const owner = (ownerData: any) => {
    if (data) {
      return ownerData.is_for_other ? "temp_user" : "creator";
    } else {
      return "";
    }
  };

  const Card = ({ title, content }: any) => {
    return (
      <div className="bg-pr_green px-4 py-3 lg:py-8 rounded-xl">
        <h6>{title}</h6>
        <h5 className="font-rokh font-[900] mt-2">{content}</h5>
      </div>
    );
  };

  return (
    <div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mt-5">
        <Card
          title="آزمایش‌دهنده:"
          content={`${
            //@ts-ignore
            `${data[owner(data)].first_name} ${
              //@ts-ignore
              data[owner(data)].last_name
            }`
          }`}
        />
        <Card
          title="نوع تحلیل:"
          content={`${data.is_pro_analysis ? "تحلیل پیشرفته" : "تحلیل پایه"}`}
        />
        <Card
          title="تاریخ ایجاد آزمایش:"
          content={`${formateDateToJalali(data.created_at)}`}
        />
        <Card
          title="جنسیت:"
          content={`${genderConverter(data[owner(data)].gender)}`}
        />
        <Card
          title="تاریخ تولد:"
          content={`${formateDateToJalali(data[owner(data)].birth_day)}`}
        />
        <Card
          title="نوع کاربر:"
          content={`${data.is_for_other ? "کاربر زیرمجموعه" : "کاربر اصلی"}`}
        />
        <Card
          title="تاریخ انجام آزمایش:"
          content={`${formateDateToJalali(data.test_date)}`}
        />
        <Card
          title="توکن‌های مصرف‌شده:"
          content={`${data.completion_tokens ?? "-"}`}
        />
      </div>
    </div>
  );
};

export default TestInfo;
